import _ from 'lodash';

export interface IHasId {
  id: string;
}

// checks that the id field is not undefined or null.
// the id field **might** be an empty string.
export function hasId(obj: { id?: string | null }): obj is IHasId {
  return !_.isNil(obj.id);
}
